const values = [
	{
		text: "Unbekannt",
	},
	{
		text: "Schnittqualität nicht zufriedenstellend",
	},
	{
		text: "Oberfläche übermässig zerkratzt",
	},
	{
		text: "Fehlende Ausschnitte",
	},
	{
		text: "Fehlerhafte Abkantung",
	},
	{
		text: "Masse ausserhalb der Toleranz",
	},
	{
		text: "Transportschaden",
	},
	{
		text: "Teile fehlen in Lieferung",
	},
	{
		text: "Andere Beanstandung",
	},
	{
		text: "Falsche Schliffrichtung",
	},
	{
		text: "Fehlende, falsche oder mangelhafte Pulverbeschichtung",
	},
	{
		text: "Fehlende, falsche oder mangelhafte Schweissnaht",
	},
	{
		text: "Gewinde, Senkung oder Durchzug fehlt oder ist mangelhaft",
	},
	{
		text: "Fehlende, falsche oder mangelhafte Verzinkung",
	},
	{
		text: "Einpressung fehlt oder entspricht nicht der Bestellung",
	},
];

export default values;
